import React, { useState, useEffect } from "react";
import CardProduct from "../components/CardProduct/CardProduct";
import CarrosselAvaliacoes from "./carrossel-avaliacoes/carrossel-avaliacoes";
import { Bannerpromo } from "../components/Bannerpromo/Bannerpromo";
import TitlePage from "../components/TitlesPages/TitlesPages";
import { productsServices } from "../services/productsServices";
import ProductFilter from "../components/FilterProduct/FilterProduct";

function Home() {
  const [productsLancamento, setProductsLancamento] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await productsServices.getProductsByRecent();
        setProductsLancamento(response);
        setFilteredProducts(response); // Inicializa os produtos filtrados
        console.log(response);
      } catch (error) {
        console.error("Erro ao buscar produtos recentes:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>Erro ao buscar produtos recentes: {error.message}</div>;
  }

  return (
    <>
      <Bannerpromo />
      <TitlePage title="lancamentos" />

      <div className="flex flex-col md:flex-row gap-4 px-1 md:px-0 md:gap-4 xl:px-4 xl:gap-4">
        {/* Sidebar de filtros */}
        <div className="w-full md:w-1/6 sticky top-4 self-start">
          <ProductFilter
            products={productsLancamento}
            updateFilteredProducts={setFilteredProducts}
          />
        </div>

        {/* Área dos cards */}
        <div className="w-full md:w-4/5">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 justify-items-center">
            {filteredProducts.map((product) => (
              <CardProduct key={product.id} product={product} />
            ))}
          </div>
        </div>
      </div>

      <CarrosselAvaliacoes />
    </>
  );
}

export default Home;
